"use strict";
/* globals module */
/**
 * @module calendarRsvpBatchRoute
 * @description BaasicCalendarRsvpBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarRsvpBatch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../../common");
var contracts_1 = require("../../../../core/contracts");
var CalendarRsvpBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarRsvpBatchRoute, _super);
    function CalendarRsvpBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.linkRoute = 'calendars/{calendarId}/rsvp-details/batch';
        _this.updateRoute = 'calendars/{calendarId}/rsvp-details/batch';
        _this.unlinkRoute = 'calendars/{calendarId}/rsvp-details/batch';
        return _this;
    }
    /**
     * Parses link route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @example calendarRsvpBatchRoute.link(calendarId);
     */
    CalendarRsvpBatchRoute.prototype.link = function (calendarId) {
        var params = {};
        params.calendarId = calendarId;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @example calendarRsvpBatchRoute.update(calendarId);
     */
    CalendarRsvpBatchRoute.prototype.update = function (calendarId) {
        var params = {};
        params.calendarId = calendarId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, params);
    };
    /**
     * Parses unlink route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @example calendarRsvpBatchRoute.unlink(calendarId);
     */
    CalendarRsvpBatchRoute.prototype.unlink = function (calendarId) {
        var params = {};
        params.calendarId = calendarId;
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, params);
    };
    var _a;
    CalendarRsvpBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarRsvpBatchRoute);
    return CalendarRsvpBatchRoute;
}(common_1.BaseRoute));
exports.CalendarRsvpBatchRoute = CalendarRsvpBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
